import React, { useEffect, useState, useRef } from "react";
import { Upload, Flex, Radio, notification, InputNumber, Select } from "antd";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useLocation, useNavigate } from "react-router-dom";

import {
  addeditdata,
  getPermission,
} from "../../../controllers/subAdmin/subAdminControllers";
import { fetchIpAddress } from "../../../controllers/API";

import LoadingEffect from "../../../components/Loading/LoadingEffect";
import {
  faArrowLeft,
  faCheckCircle,
  faInfoCircle,
  faWebAwesome,
} from "@fortawesome/free-solid-svg-icons";

const UserListEditPage = () => {
  const { Option } = Select;
  const loginUserData = JSON.parse(sessionStorage.getItem("ADMIN-INFO"));
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditSata] = useState(state ? state : []);

  const [isLoading, setIsLoading] = useState(false);
  const [enableNotification, setEnableNotification] = useState(
    ADDEDITDATA?.notification || "N",
  );

  const [drawTimeRestriction, setDrawTimeRestriction] = useState(
    ADDEDITDATA?.draw_time_restriction || "N",
  );

  /***************  Define Permission States ***************/
  const [assignPermission, setAssignPermission] = useState("");
  const [invoicePermission, setInvoicePermission] = useState({
    individual: "N",
    bulk_request: "N",
  });

  const [customerDuePermission, setCustomerDuePermission] = useState({
    customer_list: "N",
    export: "N",
    update_due: "N",
    update_collection: "N",
    collect: "N",
    settle: "N",
  });

  const [salesAgentPermission, setSalesAgentPermission] = useState({
    list: "N",
    add: "N",
    edit: "N",
    change_status: "N",
  });

  const [transactionPermission, setTransactionPermission] = useState({
    list: "N",
    export: "N",
    reverse: "N",
  });
  const [analyserPermission, setAnalyserPermission] = useState({
    list: "N",
    export: "N",
    upload: "N",
  });
  const [hourlyAnalyserPermission, setHourlyAnalyserPermission] = useState({
    list: "N",
    export: "N",
    settings: "N",
    search: "N",
    winningCouponsCache: "N",
  });

  const [winnerVoucherPermission, setWinnerVoucherPermission] = useState({
    list: "N",
    add: "N",
    remove: "N",
    assign: "N",
    verify: "N",
    download: "N",
  });

  const [userRequestPermission, setUserRequestPermission] = useState({
    list: "N",
    view: "N",
    reject: "N",
    complete: "N",
    deployment_chnage_ststus: "N",
    bdm_chnage_ststus: "N",
  });

  const [userPullOutRequestPermission, setUserPullOutRequestPermission] =
    useState({
      list: "N",
      view: "N",
      reject: "N",
      complete: "N",
      deployment_chnage_ststus: "N",
      account_chnage_ststus: "N",
      bdm_chnage_ststus: "N",
    });

  const [notificationPermission, setNotificationPermission] = useState({
    list: "N",
    details: "N",
    send: "N",
    change_read_status: "N", // Change read status
    change_status: "N", // Change status
    delete: "N", // Delete notification
  });

  /*********************** End ************************ */
  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleChange = (e) => {
    const { name, value } = e.target;

    setAddEditSata((pre) => ({
      ...pre,
      [name]: value,
    }));

    setError((pre) => ({
      ...pre,
      [name]: "",
    }));
  };

  const handleDrawClick = async (name) => {
    try {
      if (name === "draw_one") {
        setAddEditSata((pre) => ({
          ...pre,
          [name]: ADDEDITDATA?.draw_one === "Y" ? "N" : "Y",
        }));
      } else if (name === "draw_two") {
        setAddEditSata((pre) => ({
          ...pre,
          [name]: ADDEDITDATA?.draw_two === "Y" ? "N" : "Y",
        }));
      } else if (name === "draw_three") {
        setAddEditSata((pre) => ({
          ...pre,
          [name]: ADDEDITDATA?.draw_three === "Y" ? "N" : "Y",
        }));
      } else if (name === "draw_four") {
        setAddEditSata((pre) => ({
          ...pre,
          [name]: ADDEDITDATA?.draw_four === "Y" ? "N" : "Y",
        }));
      }
    } catch (error) {}
  };
  /*********************************************************
   *  This function is used to handle phone number change
   *********************************************************/
  const handlePhoneChange = (value) => {
    setAddEditSata((prev) => ({
      ...prev,
      admin_phone: value,
    }));
    setError((prev) => ({
      ...prev,
      admin_phone: "", // Clear previous error message
    }));
  };
  /*********************************************************
   *  This function is used to handle phone code change
   *********************************************************/
  const handlePhoneCodeChange = (value) => {
    setAddEditSata((prev) => ({
      ...prev,
      vendor_country_code: value,
      vendor_phone: "", // Clear phone number
    }));
    setError((prev) => ({
      ...prev,
      vendor_phone: "", // Clear previous error message
    }));
  };

  /*********************************************************
   *  OTP Box State & Handlers
   *********************************************************/
  const OTP_LENGTH = 6;
  const otpRefs = useRef([]);

  const getOtpDigits = () => {
    const raw = String(ADDEDITDATA?.static_otp || "");
    const digits = raw.split("").slice(0, OTP_LENGTH);
    while (digits.length < OTP_LENGTH) digits.push("");
    return digits;
  };

  const otpDigits = getOtpDigits();

  const updateOtpValue = (digits) => {
    const joined = digits.join("");
    setAddEditSata((prev) => ({ ...prev, static_otp: joined }));
    setError((prev) => ({ ...prev, static_otp: "" }));
  };

  const handleOtpChange = (e, idx) => {
    const val = e.target.value;
    if (val && !/^\d$/.test(val)) return;
    const digits = getOtpDigits();
    digits[idx] = val;
    updateOtpValue(digits);
    if (val && idx < OTP_LENGTH - 1) {
      otpRefs.current[idx + 1]?.focus();
    }
  };

  const handleOtpKeyDown = (e, idx) => {
    if (e.key === "Backspace") {
      const digits = getOtpDigits();
      if (digits[idx]) {
        digits[idx] = "";
        updateOtpValue(digits);
      } else if (idx > 0) {
        otpRefs.current[idx - 1]?.focus();
        digits[idx - 1] = "";
        updateOtpValue(digits);
      }
      e.preventDefault();
    } else if (e.key === "ArrowLeft" && idx > 0) {
      otpRefs.current[idx - 1]?.focus();
    } else if (e.key === "ArrowRight" && idx < OTP_LENGTH - 1) {
      otpRefs.current[idx + 1]?.focus();
    }
  };

  const handleOtpPaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, OTP_LENGTH);
    if (!pasted) return;
    const digits = pasted.split("");
    while (digits.length < OTP_LENGTH) digits.push("");
    updateOtpValue(digits);
    const focusIdx = Math.min(pasted.length, OTP_LENGTH - 1);
    otpRefs.current[focusIdx]?.focus();
  };

  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const ipAddress = await fetchIpAddress();
      const form = new FormData(event.target);
      if (
        ADDEDITDATA?._id &&
        ADDEDITDATA?._id !== "undefined" &&
        ADDEDITDATA?._id !== null
      ) {
        form.append("edit_id", ADDEDITDATA?._id);
      }
      form.append("draw_one", ADDEDITDATA?.draw_one);
      form.append("draw_two", ADDEDITDATA?.draw_two);
      form.append("draw_three", ADDEDITDATA?.draw_three);
      form.append("draw_four", ADDEDITDATA?.draw_four);
      form.append("admin_phone", ADDEDITDATA?.admin_phone);
      form.append("notification", enableNotification === "Y" ? "Y" : "N");
      form.append("draw_time_restriction", drawTimeRestriction === "Y" ? "Y" : "N");
      form.append("ipAddress", ipAddress);
      const isValidate = validateFormData(form);
      const permissions = {
        customer_due: customerDuePermission,
        salesAgent: salesAgentPermission,
        invoice: invoicePermission,
        transaction: transactionPermission,
        analyser: analyserPermission,
        hourlyAnalyser: hourlyAnalyserPermission,
        winnerVoucher: winnerVoucherPermission,
        userRequest: userRequestPermission,
        userPullOutRequest: userPullOutRequestPermission,
        notification: notificationPermission,
      };
      if (isValidate) {
        const rowData = {};
        form.forEach((value, key) => {
          rowData[key] = value;
        });
        const options = {
          url: `users/create-sub-admin/${ADDEDITDATA?._id ? ADDEDITDATA?._id : ":editId"}`,
          postData: { ...rowData, permissions },
        };

        const res = await addeditdata(options);
        if (res.status === true) {
          notification.open({
            message: "Data updated.",
            description: `Data updated Successfully.`,
            placement: "topRight",
            icon: (
              <FontAwesomeIcon
                style={{ color: "green" }}
                icon={faCheckCircle}
              />
            ),
            duration: 2,
          });
          navigate("/sub-admin/list");
        } else {
          notification.open({
            message: "Oops!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: (
              <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />
            ),
            duration: 2,
          });
        }
      } else {
        notification.open({
          message: "Oops!",
          description: `Please enter the required fields.`,
          placement: "topRight",
          icon: (
            <FontAwesomeIcon style={{ color: "red" }} icon={faInfoCircle} />
          ),
        });
      }
      setIsLoading(false);
    } catch (error) {
      console.log("error", error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  /*********************************************************
   *  This function is used to validate form data before submit
   *********************************************************/
  const validateFormData = (formData) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const vendor_country_code = "+971";
    if (!formData.get("admin_first_name")?.trim()) {
      setError((prevError) => ({
        ...prevError,
        admin_first_name: "First name is required",
      }));
      return false;
    }
    if (!formData.get("admin_last_name")?.trim()) {
      setError((prevError) => ({
        ...prevError,
        admin_last_name: "Last name is required",
      }));
      return false;
    }
    if (!formData.get("admin_email")?.trim()) {
      setError((prevError) => ({
        ...prevError,
        admin_email: "Email address is required",
      }));
      return false;
    }
    if (!formData.get("account_id")?.trim()) {
      setError((prevError) => ({
        ...prevError,
        account_id: "Account ID is required.",
      }));
      return false;
    }
    if (!emailPattern.test(formData.get("admin_email"))) {
      setError((prevError) => ({
        ...prevError,
        admin_email: "Please enter a valid email address",
      }));
      return false;
    }
    const phone = formData.get("admin_phone");
    if (
      !phone?.trim() ||
      (vendor_country_code === "+91" && phone.length !== 10) ||
      (vendor_country_code === "+971" && phone.length !== 9)
    ) {
      setError((prevError) => ({
        ...prevError,
        admin_phone: !phone
          ? "Phone number is required"
          : `Phone number must be exactly ${
              vendor_country_code === "+91" ? 10 : 9
            } digits for ${vendor_country_code === "+91" ? "India" : "UAE"}`,
      }));
      return false;
    }

    return true;
  };

  const getUserpermission = async () => {
    try {
      setIsLoading(true);
      const option = { admin_id: ADDEDITDATA?._id };
      const res = await getPermission(option);
      if (res.status === true && res.result !== "undefined") {
        setIsLoading(false);

        setInvoicePermission(res.result?.invoice);
        setCustomerDuePermission(res.result?.customer_due);
        setSalesAgentPermission(res.result?.salesAgent);
        setTransactionPermission(res.result?.transaction);
        setAnalyserPermission(res.result?.analyser);
        setHourlyAnalyserPermission({
          list: "N",
          export: "N",
          settings: "N",
          search: "N",
          winningCouponsCache: "N",
          ...(res.result?.hourlyAnalyser || {}),
        });
        setWinnerVoucherPermission(res.result?.winnerVoucher);
        setUserRequestPermission(res.result?.userRequest);
        setUserPullOutRequestPermission(res.result?.userPullOutRequest);
        setNotificationPermission(res.result?.notification);
      } else {
        setAssignPermission([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (ADDEDITDATA?._id) {
      getUserpermission();
    }
    document.title = `U-Winn CRM Admin || ${
      ADDEDITDATA?._id ? "Edit" : "Add"
    } Sub Admin`;
  }, []);

  /*********************************************************
   *  This function is used to handle permissions dynamically
   *********************************************************/
  const handlePermission = (type, value) => {
    try {
      // console.log('type',type); //customer_due
      // console.log('value',value); // customer_list
      if (type === "invoice") {
        setInvoicePermission((prev = {}) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if (type === "customer_due") {
        setCustomerDuePermission((prev = {}) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if (type === "salesAgent") {
        setSalesAgentPermission((prev = {}) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if (type === "transaction") {
        setTransactionPermission((prev = {}) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if (type === "analyser") {
        setAnalyserPermission((prev = {}) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if (type === "hourlyAnalyser") {
        setHourlyAnalyserPermission((prev = {}) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if (type === "winnerVoucher") {
        setWinnerVoucherPermission((prev = {}) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if (type === "userRequest") {
        setUserRequestPermission((prev = {}) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if (type === "userPullOutRequest") {
        setUserPullOutRequestPermission((prev = {}) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      } else if (type === "notification") {
        setNotificationPermission((prev = {}) => ({
          ...prev,
          [value]: prev[value] === "Y" ? "N" : "Y",
        }));
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  return (
    <div>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <React.Fragment>
            <h5 className="inventory_edit_page_heading">
              {" "}
              {ADDEDITDATA?._id ? `Edit` : `Add`} Sub Admin{" "}
            </h5>
          </React.Fragment>
          <Link
            to={
              ADDEDITDATA.admin_type === "Super Admin"
                ? "/sub-admin/list"
                : "/dashboard"
            }
          >
            <React.Fragment>
              <button type="button" className="btn btn-secondary">
                {" "}
                <FontAwesomeIcon icon={faArrowLeft} /> Back{" "}
              </button>
            </React.Fragment>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form
                method="post"
                className="inventory_form_main_contnet"
                onSubmit={handleSubmit}
              >
                <div className="row ">
                  <div className="row">
                    <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="admin_first_name"
                        className="all_section_for_label_main_class"
                      >
                        <span style={{ color: "red" }}>*</span>First Name :{" "}
                      </label>
                      <input
                        title="Enter your first name."
                        placeholder="Enter your first name."
                        type="text"
                        name="admin_first_name"
                        className="form-control store_input_field"
                        id="admin_first_name"
                        value={ADDEDITDATA?.admin_first_name}
                        onChange={handleChange}
                      />
                      {error.admin_first_name ? (
                        <p style={{ color: "red" }}>{error.admin_first_name}</p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="admin_last_name"
                        className="all_section_for_label_main_class"
                      >
                        <span style={{ color: "red" }}>*</span>Last Name :{" "}
                      </label>
                      <input
                        title="Enter your last name."
                        placeholder="Enter your last name."
                        type="text"
                        name="admin_last_name"
                        className="form-control store_input_field"
                        id="admin_last_name"
                        value={ADDEDITDATA?.admin_last_name}
                        onChange={handleChange}
                      />
                      {error.admin_last_name ? (
                        <p style={{ color: "red" }}>{error.admin_last_name}</p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="admin_email"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Email Address :
                      </label>
                      <input
                        title="Enter your email address."
                        placeholder="Enter your email address."
                        type="text"
                        name="admin_email"
                        className="form-control store_input_field"
                        id="admin_email"
                        value={ADDEDITDATA?.admin_email}
                        readOnly={ADDEDITDATA?._id ? true : false}
                        onChange={handleChange}
                      />
                      {error.admin_email ? (
                        <p style={{ color: "red" }}>{error.admin_email}</p>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  <div className="row">
                    {/* Second row: Phone Number and Department */}
                    <div className="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="admin_phone"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Phone Number:
                      </label>
                      <br />
                      <InputNumber
                        style={{ width: "100%" }}
                        onChange={handlePhoneChange}
                        addonBefore={
                          <Select
                            defaultValue={"+971"}
                            style={{ width: 110 }}
                            onChange={handlePhoneCodeChange}
                          >
                            <Option value="+971" selected={true}>
                              +971 (UAE)
                            </Option>
                          </Select>
                        }
                        value={ADDEDITDATA?.admin_phone}
                      />
                      {error.admin_phone ? (
                        <p style={{ color: "red" }}>{error.admin_phone}</p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="department_name"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Department Name :
                      </label>
                      <input
                        title="Enter department name."
                        placeholder="Enter department name."
                        type="text"
                        name="department_name"
                        className="form-control store_input_field"
                        id="department_name"
                        value={ADDEDITDATA?.department_name}
                        onChange={handleChange}
                      />
                      {error.department_name ? (
                        <p style={{ color: "red" }}>{error.department_name}</p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="account_id"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Account ID :
                      </label>
                      <input
                        title="Enter account id"
                        placeholder="Enter account id"
                        type="text"
                        name="account_id"
                        className="form-control store_input_field"
                        id="account_id"
                        value={ADDEDITDATA?.account_id}
                        onChange={handleChange}
                      />
                      {error.account_id ? (
                        <p style={{ color: "red" }}>{error.account_id}</p>
                      ) : (
                        ""
                      )}
                    </div>
                    {loginUserData.admin_type === "Super Admin" &&
                      ADDEDITDATA.admin_type !== "Super Admin" && (
                        <>
                          <div className="row" style={{ marginTop: "10px" }}>
                            <div className="form-group col-lg-4 col-md-5 col-sm-12 col-xs-12 vendor_Add_edit_data">
                              <label
                                htmlFor="enable_static_otp"
                                className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                              >
                                <span style={{ color: "red" }}>*</span>Enable
                                Static OTP :
                              </label>
                              <select
                                name="enable_static_otp"
                                id="enable_static_otp"
                                className="form-control store_input_field"
                                value={ADDEDITDATA?.enable_static_otp || "N"}
                                onChange={handleChange}
                                style={{
                                  height: "42px",
                                  borderRadius: "8px",
                                  border: "1.5px solid #d9d9d9",
                                  fontSize: "14px",
                                  cursor: "pointer",
                                  transition: "border-color 0.3s",
                                }}
                              >
                                <option value="Y">Yes</option>
                                <option value="N">No</option>
                              </select>
                            </div>

                            <div className="form-group col-lg-8 col-md-7 col-sm-12 col-xs-12 vendor_Add_edit_data">
                              <label
                                htmlFor="static_otp"
                                className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                              >
                                <span style={{ color: "red" }}>*</span>Static
                                OTP :
                              </label>
                              <input
                                type="hidden"
                                name="static_otp"
                                value={ADDEDITDATA?.static_otp || ""}
                              />
                              <div
                                style={{
                                  display: "flex",
                                  gap: "10px",
                                  marginTop: "-1px",
                                }}
                              >
                                {otpDigits.map((digit, idx) => (
                                  <input
                                    key={idx}
                                    ref={(el) => (otpRefs.current[idx] = el)}
                                    type="text"
                                    inputMode="numeric"
                                    maxLength={1}
                                    value={digit}
                                    onChange={(e) => handleOtpChange(e, idx)}
                                    onKeyDown={(e) => handleOtpKeyDown(e, idx)}
                                    onPaste={
                                      idx === 0 ? handleOtpPaste : undefined
                                    }
                                    onFocus={(e) => e.target.select()}
                                    style={{
                                      width: "42px",
                                      height: "42px",
                                      textAlign: "center",
                                      fontSize: "20px",
                                      fontWeight: "600",
                                      borderRadius: "10px",
                                      border: digit
                                        ? "2px solid #1890ff"
                                        : "1.5px solid #d9d9d9",
                                      outline: "none",
                                      transition: "all 0.2s ease",
                                      boxShadow: digit
                                        ? "0 0 0 3px rgba(24,144,255,0.12)"
                                        : "none",
                                      background: "#fafafa",
                                      color: "#222",
                                      caretColor: "#1890ff",
                                    }}
                                  />
                                ))}
                              </div>
                              {error.static_otp ? (
                                <p style={{ color: "red", marginTop: "6px" }}>
                                  {error.static_otp}
                                </p>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          
                          <div className="from-group col-lg-4 col-md-12 col-sm-12 col-xs-12">
                            <label
                              htmlFor="Accounts"
                              className="all_top_and_bottom_for_input_text"
                            >
                             Notification
                            </label>
                            <Flex vertical gap="draw_one" className="">
                              <div
                                className="verndor_dashboard_add_edit_button"
                                defaultValue="Y"
                                name="in_store"
                                id="in_store"
                                size="large"
                              >
                                <div
                                  className="row"
                                  onClick={() =>
                                    setEnableNotification(
                                      enableNotification === "Y" ? "N" : "Y",
                                    )}
                                >
                                  <div className="col-lg-12 col-md-12 col-sm-6 col-xs-12">
                                    <div className="vendor_dashbaord_gender_main_section">
                                      <label htmlFor="draw_one">
                                        Enable
                                      </label>
                                      <input
                                        type="checkbox"
                                        id="draw_one"
                                        name="draw_one"
                                        value="Y"
                                        className="form-check-input"
                                        disabled={true}
                                        checked={
                                          enableNotification === "Y"
                                            ? true
                                            : false
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Flex>
                          </div>
                          <div className="from-group col-lg-4 col-md-12 col-sm-12 col-xs-12">
                            <label
                              htmlFor="Accounts"
                              className="all_top_and_bottom_for_input_text"
                            >
                             Draw Time Restriction
                            </label>
                            <Flex vertical gap="draw_one" className="">
                              <div
                                className="verndor_dashboard_add_edit_button"
                                defaultValue="Y"
                                name="in_store"
                                id="in_store"
                                size="large"
                              >
                                <div
                                  className="row"
                                  onClick={() =>
                                    setDrawTimeRestriction(
                                      drawTimeRestriction === "Y" ? "N" : "Y",
                                    )}
                                >
                                  <div className="col-lg-12 col-md-12 col-sm-6 col-xs-12">
                                    <div className="vendor_dashbaord_gender_main_section">
                                      <label htmlFor="drawTimeRestriction">
                                        Enable
                                      </label>
                                      <input
                                        type="checkbox"
                                        id="drawTimeRestriction"
                                        name="drawTimeRestriction"
                                        value="Y"
                                        className="form-check-input"
                                        disabled={true}
                                        checked={
                                          drawTimeRestriction === "Y"
                                            ? true
                                            : false
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Flex>
                          </div>
                         
                          <div className="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                            
                          </div>

                          

                          {/* Draw One */}
                          <div className="from-group col-lg-4 col-md-12 col-sm-12 col-xs-12">
                            <label
                              htmlFor="Accounts"
                              className="all_top_and_bottom_for_input_text"
                            >
                              {" "}
                              Draw One :{" "}
                            </label>
                            <Flex vertical gap="draw_one" className="">
                              <div
                                className="verndor_dashboard_add_edit_button"
                                defaultValue="Y"
                                name="in_store"
                                id="in_store"
                                size="large"
                              >
                                <div
                                  className="row"
                                  onClick={() => handleDrawClick("draw_one")}
                                >
                                  <div className="col-lg-12 col-md-12 col-sm-6 col-xs-12">
                                    <div className="vendor_dashbaord_gender_main_section">
                                      <label htmlFor="draw_one">
                                        10:00 PM Draw
                                      </label>
                                      <input
                                        type="checkbox"
                                        id="draw_one"
                                        name="draw_one"
                                        value="Y"
                                        className="form-check-input"
                                        disabled={true}
                                        checked={
                                          ADDEDITDATA?.draw_one === "Y"
                                            ? true
                                            : false
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Flex>
                          </div>
                          <div className="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                            <label
                              htmlFor="draw_one_start_time"
                              className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                            >
                              Start Time :
                            </label>
                            <input
                              title="Select draw start time."
                              type="time"
                              name="draw_one_start_time"
                              className="form-control store_input_field"
                              id="draw_one_start_time"
                              value={ADDEDITDATA?.draw_one_start_time}
                              onChange={handleChange}
                            />
                            {error.draw_one_start_time ? (
                              <p style={{ color: "red" }}>
                                {error.draw_one_start_time}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                            <label
                              htmlFor="draw_one_end_time"
                              className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                            >
                              End Time :
                            </label>
                            <input
                              title="Select draw end time."
                              type="time"
                              name="draw_one_end_time"
                              className="form-control store_input_field"
                              id="draw_one_end_time"
                              value={ADDEDITDATA?.draw_one_end_time}
                              onChange={handleChange}
                            />
                            {error.draw_one_end_time ? (
                              <p style={{ color: "red" }}>
                                {error.draw_one_end_time}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                          {/* Draw Two */}
                          <div className="from-group col-lg-4 col-md-12 col-sm-12 col-xs-12">
                            <label
                              htmlFor="draw_two"
                              className="all_top_and_bottom_for_input_text"
                            >
                              {" "}
                              Draw Two :{" "}
                            </label>
                            <Flex vertical gap="middle" className="">
                              <div
                                className="verndor_dashboard_add_edit_button"
                                defaultValue="Y"
                                name="in_store"
                                id="in_store"
                                size="large"
                              >
                                <div
                                  className="row"
                                  onClick={() => handleDrawClick("draw_two")}
                                >
                                  <div className="col-lg-12 col-md-12 col-sm-6 col-xs-12">
                                    <div className="vendor_dashbaord_gender_main_section">
                                      <label htmlFor="draw_two">
                                        11:00 PM Draw
                                      </label>
                                      <input
                                        type="checkbox"
                                        id="draw_two"
                                        name="draw_two"
                                        value="Y"
                                        className="form-check-input"
                                        disabled={true}
                                        checked={
                                          ADDEDITDATA?.draw_two === "Y"
                                            ? true
                                            : false
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Flex>
                          </div>
                          <div className="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                            <label
                              htmlFor="draw_two_start_time"
                              className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                            >
                              Start Time :
                            </label>
                            <input
                              title="Select draw start time."
                              type="time"
                              name="draw_two_start_time"
                              className="form-control store_input_field"
                              id="draw_two_start_time"
                              value={ADDEDITDATA?.draw_two_start_time}
                              onChange={handleChange}
                            />
                            {error.draw_two_start_time ? (
                              <p style={{ color: "red" }}>
                                {error.draw_two_start_time}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                            <label
                              htmlFor="draw_two_end_time"
                              className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                            >
                              End Time :
                            </label>
                            <input
                              title="Select draw end time."
                              placeholder="Enter account id"
                              type="time"
                              name="draw_two_end_time"
                              className="form-control store_input_field"
                              id="draw_two_end_time"
                              value={ADDEDITDATA?.draw_two_end_time}
                              onChange={handleChange}
                            />
                            {error.draw_two_end_time ? (
                              <p style={{ color: "red" }}>
                                {error.draw_two_end_time}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                          {/* Draw Three */}
                          <div className="from-group col-lg-4 col-md-12 col-sm-12 col-xs-12">
                            <label
                              htmlFor="draw_three"
                              className="all_top_and_bottom_for_input_text"
                            >
                              {" "}
                              Draw Three :{" "}
                            </label>
                            <Flex vertical gap="middle" className="">
                              <div
                                className="verndor_dashboard_add_edit_button"
                                defaultValue="Y"
                                name="in_store"
                                id="in_store"
                                size="large"
                              >
                                <div
                                  className="row"
                                  onClick={() => handleDrawClick("draw_three")}
                                >
                                  <div className="col-lg-12 col-md-12 col-sm-6 col-xs-12">
                                    <div className="vendor_dashbaord_gender_main_section">
                                      <label htmlFor="draw_three">
                                        11:30 PM Draw
                                      </label>
                                      <input
                                        type="checkbox"
                                        id="draw_three"
                                        name="draw_three"
                                        value="Y"
                                        className="form-check-input"
                                        disabled={true}
                                        checked={
                                          ADDEDITDATA?.draw_three === "Y"
                                            ? true
                                            : false
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Flex>
                          </div>
                          <div className="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                            <label
                              htmlFor="draw_three_start_time"
                              className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                            >
                              Start Time :
                            </label>
                            <input
                              title="Select draw start time."
                              type="time"
                              name="draw_three_start_time"
                              className="form-control store_input_field"
                              id="draw_three_start_time"
                              value={ADDEDITDATA?.draw_three_start_time}
                              onChange={handleChange}
                            />
                            {error.draw_three_start_time ? (
                              <p style={{ color: "red" }}>
                                {error.draw_three_start_time}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                            <label
                              htmlFor="draw_three_end_time"
                              className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                            >
                              End Time :
                            </label>
                            <input
                              title="Select draw end time."
                              placeholder="Enter account id"
                              type="time"
                              name="draw_three_end_time"
                              className="form-control store_input_field"
                              id="draw_three_end_time"
                              value={ADDEDITDATA?.draw_three_end_time}
                              onChange={handleChange}
                            />
                            {error.draw_three_end_time ? (
                              <p style={{ color: "red" }}>
                                {error.draw_three_end_time}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>

                          {/* Draw Four */}
                          <div className="from-group col-lg-4 col-md-12 col-sm-12 col-xs-12">
                            <label
                              htmlFor="draw_four"
                              className="all_top_and_bottom_for_input_text"
                            >
                              {" "}
                              Draw Four :{" "}
                            </label>
                            <Flex vertical gap="middle" className="">
                              <div
                                className="verndor_dashboard_add_edit_button"
                                defaultValue="Y"
                                name="in_store"
                                id="in_store"
                                size="large"
                              >
                                <div
                                  className="row"
                                  onClick={() => handleDrawClick("draw_four")}
                                >
                                  <div className="col-lg-12 col-md-12 col-sm-6 col-xs-12">
                                    <div className="vendor_dashbaord_gender_main_section">
                                      <label htmlFor="draw_four">
                                        11:59 PM Draw
                                      </label>
                                      <input
                                        type="checkbox"
                                        id="draw_four"
                                        name="draw_four"
                                        value="Y"
                                        className="form-check-input"
                                        disabled={true}
                                        checked={
                                          ADDEDITDATA?.draw_four === "Y"
                                            ? true
                                            : false
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Flex>
                          </div>
                          <div className="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                            <label
                              htmlFor="draw_four_start_time"
                              className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                            >
                              Start Time :
                            </label>
                            <input
                              title="Select draw start time."
                              type="time"
                              name="draw_four_start_time"
                              className="form-control store_input_field"
                              id="draw_four_start_time"
                              value={ADDEDITDATA?.draw_four_start_time}
                              onChange={handleChange}
                            />
                            {error.draw_four_start_time ? (
                              <p style={{ color: "red" }}>
                                {error.draw_four_start_time}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                            <label
                              htmlFor="draw_four_end_time"
                              className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                            >
                              End Time :
                            </label>
                            <input
                              title="Select draw end time."
                              placeholder="Enter account id"
                              type="time"
                              name="draw_four_end_time"
                              className="form-control store_input_field"
                              id="draw_four_end_time"
                              value={ADDEDITDATA?.draw_four_end_time}
                              onChange={handleChange}
                            />
                            {error.draw_four_end_time ? (
                              <p style={{ color: "red" }}>
                                {error.draw_four_end_time}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        </>
                      )}
                  </div>
                  {loginUserData.admin_type === "Super Admin" &&
                    ADDEDITDATA.admin_type !== "Super Admin" && (
                      <div className="row">
                        <label> Permission: </label>
                        {/* Customer's Due */}
                        <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <label
                            htmlFor="Accounts"
                            className="all_top_and_bottom_for_input_text"
                          >
                            {" "}
                            Customer's Due :{" "}
                          </label>
                          <Flex vertical gap="middle" className="">
                            <div
                              className="verndor_dashboard_add_edit_button"
                              size="large"
                            >
                              <div className="row">
                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission(
                                      "customer_due",
                                      "customer_list",
                                    )
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="customer_list">
                                      Customer's list
                                    </label>
                                    <input
                                      type="checkbox"
                                      id="customer_list"
                                      name="customer_list"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        customerDuePermission?.customer_list ===
                                        "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission("customer_due", "export")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="export">Export</label>
                                    <input
                                      type="checkbox"
                                      id="export"
                                      name="export"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        customerDuePermission?.export === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission(
                                      "customer_due",
                                      "update_due",
                                    )
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="update_due">
                                      Update Due
                                    </label>
                                    <input
                                      type="checkbox"
                                      id="update_due"
                                      name="update_due"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        customerDuePermission?.update_due ===
                                        "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission(
                                      "customer_due",
                                      "update_collection",
                                    )
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="update_collection">
                                      Update Collection
                                    </label>
                                    <input
                                      type="checkbox"
                                      id="update_collection"
                                      name="update_collection"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        customerDuePermission?.update_collection ===
                                        "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12 mt-3"
                                  onClick={() =>
                                    handlePermission("customer_due", "collect")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="collect">Collect</label>
                                    <input
                                      type="checkbox"
                                      id="collect"
                                      name="collect"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        customerDuePermission?.collect === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12 mt-3"
                                  onClick={() =>
                                    handlePermission("customer_due", "settle")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="settle">Settle</label>
                                    <input
                                      type="checkbox"
                                      id="settle"
                                      name="settle"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        customerDuePermission?.settle === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Flex>
                        </div>

                        <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <label
                            htmlFor="userRequest"
                            className="all_top_and_bottom_for_input_text"
                          >
                            {" "}
                            User Request :{" "}
                          </label>
                          <Flex vertical gap="middle" className="">
                            <div
                              className="verndor_dashboard_add_edit_button"
                              defaultValue="Y"
                              name="userRequest"
                              id="userRequest"
                              size="large"
                            >
                              <div className="row">
                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission("userRequest", "list")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="list">List</label>
                                    <input
                                      type="checkbox"
                                      id="list"
                                      name="list"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        userRequestPermission?.list === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission("userRequest", "view")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="view">View</label>
                                    <input
                                      type="checkbox"
                                      id="view"
                                      name="view"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        userRequestPermission?.view === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission("userRequest", "reject")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="reject">Reject</label>
                                    <input
                                      type="checkbox"
                                      id="edit"
                                      name="reject"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        userRequestPermission?.reject === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission("userRequest", "complete")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="complete">Complete</label>
                                    <input
                                      type="checkbox"
                                      id="complete"
                                      name="complete"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        userRequestPermission?.complete === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12 mt-3"
                                  onClick={() =>
                                    handlePermission(
                                      "userRequest",
                                      "bdm_chnage_ststus",
                                    )
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="bdm_chnage_ststus">
                                      BDM Change Status
                                    </label>
                                    <input
                                      type="checkbox"
                                      id="bdm_chnage_ststus"
                                      name="bdm_chnage_ststus"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        userRequestPermission?.bdm_chnage_ststus ===
                                        "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12 mt-3"
                                  onClick={() =>
                                    handlePermission(
                                      "userRequest",
                                      "deployment_chnage_ststus",
                                    )
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="deployment_chnage_ststus">
                                      Deplyment Change Status
                                    </label>
                                    <input
                                      type="checkbox"
                                      id="deployment_chnage_ststus"
                                      name="deployment_chnage_ststus"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        userRequestPermission?.deployment_chnage_ststus ===
                                        "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Flex>
                        </div>

                        <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <label
                            htmlFor="userPullOutRequest"
                            className="all_top_and_bottom_for_input_text"
                          >
                            {" "}
                            User Pull Out Request :{" "}
                          </label>
                          <Flex vertical gap="middle" className="">
                            <div
                              className="verndor_dashboard_add_edit_button"
                              defaultValue="Y"
                              name="userPullOutRequest"
                              id="userPullOutRequest"
                              size="large"
                            >
                              <div className="row">
                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission(
                                      "userPullOutRequest",
                                      "list",
                                    )
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="list">List</label>
                                    <input
                                      type="checkbox"
                                      id="list"
                                      name="list"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        userPullOutRequestPermission?.list ===
                                        "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission(
                                      "userPullOutRequest",
                                      "view",
                                    )
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="view">View</label>
                                    <input
                                      type="checkbox"
                                      id="view"
                                      name="view"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        userPullOutRequestPermission?.view ===
                                        "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission(
                                      "userPullOutRequest",
                                      "reject",
                                    )
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="reject">Reject</label>
                                    <input
                                      type="checkbox"
                                      id="edit"
                                      name="reject"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        userPullOutRequestPermission?.reject ===
                                        "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission(
                                      "userPullOutRequest",
                                      "complete",
                                    )
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="complete">Complete</label>
                                    <input
                                      type="checkbox"
                                      id="complete"
                                      name="complete"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        userPullOutRequestPermission?.complete ===
                                        "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12 mt-3"
                                  onClick={() =>
                                    handlePermission(
                                      "userPullOutRequest",
                                      "bdm_chnage_ststus",
                                    )
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="complete">
                                      BDM Change Status
                                    </label>
                                    <input
                                      type="checkbox"
                                      id="bdm_chnage_ststus"
                                      name="bdm_chnage_ststus"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        userPullOutRequestPermission?.bdm_chnage_ststus ===
                                        "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12 mt-3"
                                  onClick={() =>
                                    handlePermission(
                                      "userPullOutRequest",
                                      "deployment_chnage_ststus",
                                    )
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="complete">
                                      Deplyment Change Status
                                    </label>
                                    <input
                                      type="checkbox"
                                      id="deployment_chnage_ststus"
                                      name="deployment_chnage_ststus"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        userPullOutRequestPermission?.deployment_chnage_ststus ===
                                        "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12 mt-3"
                                  onClick={() =>
                                    handlePermission(
                                      "userPullOutRequest",
                                      "account_chnage_ststus",
                                    )
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="complete">
                                      Account Change Status
                                    </label>
                                    <input
                                      type="checkbox"
                                      id="account_chnage_ststus"
                                      name="account_chnage_ststus"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        userPullOutRequestPermission?.account_chnage_ststus ===
                                        "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Flex>
                        </div>

                        <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <label
                            htmlFor="salesAgent"
                            className="all_top_and_bottom_for_input_text"
                          >
                            {" "}
                            Sales Agent :{" "}
                          </label>
                          <Flex vertical gap="middle" className="">
                            <div
                              className="verndor_dashboard_add_edit_button"
                              defaultValue="Y"
                              name="salesAgent"
                              id="salesAgent"
                              size="large"
                            >
                              <div className="row">
                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission("salesAgent", "list")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="list">List</label>
                                    <input
                                      type="checkbox"
                                      id="list"
                                      name="list"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        salesAgentPermission?.list === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission("salesAgent", "add")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="add">Add</label>
                                    <input
                                      type="checkbox"
                                      id="add"
                                      name="add"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        salesAgentPermission?.add === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission("salesAgent", "edit")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="edit">Edit</label>
                                    <input
                                      type="checkbox"
                                      id="edit"
                                      name="edit"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        salesAgentPermission?.edit === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission(
                                      "salesAgent",
                                      "change_status",
                                    )
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="change_status">
                                      Change Status
                                    </label>
                                    <input
                                      type="checkbox"
                                      id="change_status"
                                      name="change_status"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        salesAgentPermission?.change_status ===
                                        "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Flex>
                        </div>

                        <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <label
                            htmlFor="Accounts"
                            className="all_top_and_bottom_for_input_text"
                          >
                            {" "}
                            Invoice :{" "}
                          </label>
                          <Flex vertical gap="middle" className="">
                            <div
                              className="verndor_dashboard_add_edit_button"
                              defaultValue="Y"
                              name="in_store"
                              id="in_store"
                              size="large"
                            >
                              <div className="row">
                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission("invoice", "individual")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="individual">
                                      Individual
                                    </label>
                                    <input
                                      type="checkbox"
                                      id="individual"
                                      name="individual"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        invoicePermission?.individual === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission("invoice", "bulk_request")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="bulk_request">
                                      Bulk Request
                                    </label>
                                    <input
                                      type="checkbox"
                                      id="bulk_request"
                                      name="bulk_request"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        invoicePermission?.bulk_request === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Flex>
                        </div>

                        <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <label
                            htmlFor="Accounts"
                            className="all_top_and_bottom_for_input_text"
                          >
                            {" "}
                            Transaction :{" "}
                          </label>
                          <Flex vertical gap="middle" className="">
                            <div
                              className="verndor_dashboard_add_edit_button"
                              defaultValue="Y"
                              name="in_store"
                              id="in_store"
                              size="large"
                            >
                              <div className="row">
                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission("transaction", "list")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="list">List</label>
                                    <input
                                      type="checkbox"
                                      id="list"
                                      name="list"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        transactionPermission?.list === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission("transaction", "export")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="export">Export</label>
                                    <input
                                      type="checkbox"
                                      id="export"
                                      name="export"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        transactionPermission?.export === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission("transaction", "reverse")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="reverse">Reverse</label>
                                    <input
                                      type="checkbox"
                                      id="reverse"
                                      name="reverse"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        transactionPermission?.reverse === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Flex>
                        </div>

                        <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <label
                            htmlFor="Accounts"
                            className="all_top_and_bottom_for_input_text"
                          >
                            {" "}
                            Analyser :{" "}
                          </label>
                          <Flex vertical gap="middle" className="">
                            <div
                              className="verndor_dashboard_add_edit_button"
                              defaultValue="Y"
                              name="in_store"
                              id="in_store"
                              size="large"
                            >
                              <div className="row">
                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission("analyser", "list")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="list">List</label>
                                    <input
                                      type="checkbox"
                                      id="list"
                                      name="list"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        analyserPermission?.list === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission("analyser", "export")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="export">Export</label>
                                    <input
                                      type="checkbox"
                                      id="export"
                                      name="export"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        analyserPermission?.export === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission("analyser", "upload")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="upload">Upload</label>
                                    <input
                                      type="checkbox"
                                      id="upload"
                                      name="upload"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        analyserPermission?.upload === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Flex>
                        </div>

                        <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <label
                            htmlFor="Accounts"
                            className="all_top_and_bottom_for_input_text"
                          >
                            {" "}
                            Hourly Analyser :{" "}
                          </label>
                          <Flex vertical gap="middle" className="">
                            <div
                              className="verndor_dashboard_add_edit_button"
                              defaultValue="Y"
                              name="hourlyAnalyser"
                              id="hourlyAnalyser"
                              size="large"
                            >
                              <div className="row">
                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission("hourlyAnalyser", "list")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="hourlyAnalyserList">
                                      List
                                    </label>
                                    <input
                                      type="checkbox"
                                      id="hourlyAnalyserList"
                                      name="hourlyAnalyserList"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        hourlyAnalyserPermission?.list === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission("hourlyAnalyser", "export")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="hourlyAnalyserExport">
                                      Export
                                    </label>
                                    <input
                                      type="checkbox"
                                      id="hourlyAnalyserExport"
                                      name="hourlyAnalyserExport"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        hourlyAnalyserPermission?.export === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission(
                                      "hourlyAnalyser",
                                      "settings",
                                    )
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="hourlyAnalyserSettings">
                                      Settings
                                    </label>
                                    <input
                                      type="checkbox"
                                      id="hourlyAnalyserSettings"
                                      name="hourlyAnalyserSettings"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        hourlyAnalyserPermission?.settings ===
                                        "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission("hourlyAnalyser", "search")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="hourlyAnalyserSearch">
                                      Search
                                    </label>
                                    <input
                                      type="checkbox"
                                      id="hourlyAnalyserSearch"
                                      name="hourlyAnalyserSearch"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        hourlyAnalyserPermission?.search === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission(
                                      "hourlyAnalyser",
                                      "winningCouponsCache",
                                    )
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="hourlyAnalyserWinningCouponsCache">
                                      Winning Coupons Cache
                                    </label>
                                    <input
                                      type="checkbox"
                                      id="hourlyAnalyserWinningCouponsCache"
                                      name="hourlyAnalyserWinningCouponsCache"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        hourlyAnalyserPermission?.winningCouponsCache ===
                                        "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Flex>
                        </div>

                        <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <label
                            htmlFor="Accounts"
                            className="all_top_and_bottom_for_input_text"
                          >
                            {" "}
                            Winner Voucher :{" "}
                          </label>
                          <Flex vertical gap="middle" className="">
                            <div
                              className="verndor_dashboard_add_edit_button"
                              defaultValue="Y"
                              name="winnerVoucher"
                              id="winnerVoucher"
                              size="large"
                            >
                              <div className="row">
                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission("winnerVoucher", "list")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="list">List</label>
                                    <input
                                      type="checkbox"
                                      id="list"
                                      name="list"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        winnerVoucherPermission?.list === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission("winnerVoucher", "add")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="add">Add</label>
                                    <input
                                      type="checkbox"
                                      id="add"
                                      name="add"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        winnerVoucherPermission?.add === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission("winnerVoucher", "remove")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="remove">Remove</label>
                                    <input
                                      type="checkbox"
                                      id="remove"
                                      name="remove"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        winnerVoucherPermission?.remove === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission("winnerVoucher", "assign")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="assign">Assign</label>
                                    <input
                                      type="checkbox"
                                      id="assign"
                                      name="assign"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        winnerVoucherPermission?.assign === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12 mt-3"
                                  onClick={() =>
                                    handlePermission("winnerVoucher", "verify")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="verify">Verify</label>
                                    <input
                                      type="checkbox"
                                      id="verify"
                                      name="verify"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        winnerVoucherPermission?.verify === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>

                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12 mt-3"
                                  onClick={() =>
                                    handlePermission(
                                      "winnerVoucher",
                                      "download",
                                    )
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="download">Download</label>
                                    <input
                                      type="checkbox"
                                      id="download"
                                      name="download"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        winnerVoucherPermission?.download ===
                                        "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Flex>
                        </div>

                        <div className="from-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <label
                            htmlFor="Accounts"
                            className="all_top_and_bottom_for_input_text"
                          >
                            {" "}
                            Notification :{" "}
                          </label>
                          <Flex vertical gap="middle" className="">
                            <div
                              className="verndor_dashboard_add_edit_button"
                              defaultValue="Y"
                              name="notification"
                              id="notification"
                              size="large"
                            >
                              <div className="row">
                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission("notification", "list")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="list">List</label>
                                    <input
                                      type="checkbox"
                                      id="list"
                                      name="list"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        notificationPermission?.list === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>
                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission("notification", "details")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="list">Details</label>
                                    <input
                                      type="checkbox"
                                      id="details"
                                      name="details"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        notificationPermission?.details === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>
                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission("notification", "send")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="send">Send</label>
                                    <input
                                      type="checkbox"
                                      id="send"
                                      name="send"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        notificationPermission?.send === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>
                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12"
                                  onClick={() =>
                                    handlePermission(
                                      "notification",
                                      "change_read_status",
                                    )
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="change_read_status">
                                      Change Read Status
                                    </label>
                                    <input
                                      type="checkbox"
                                      id="change_read_status"
                                      name="change_read_status"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        notificationPermission?.change_read_status ===
                                        "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>
                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12 mt-3"
                                  onClick={() =>
                                    handlePermission(
                                      "notification",
                                      "change_status",
                                    )
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="change_status">
                                      Change Status
                                    </label>
                                    <input
                                      type="checkbox"
                                      id="change_status"
                                      name="change_status"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        notificationPermission?.change_status ===
                                        "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>
                                <div
                                  className="col-lg-3 col-md-3 col-sm-6 col-xs-12 mt-3"
                                  onClick={() =>
                                    handlePermission("notification", "delete")
                                  }
                                >
                                  <div className="vendor_dashbaord_gender_main_section">
                                    <label htmlFor="delete">Delete</label>
                                    <input
                                      type="checkbox"
                                      id="delete"
                                      name="delete"
                                      value="Y"
                                      className="form-check-input"
                                      disabled={true}
                                      checked={
                                        notificationPermission?.delete === "Y"
                                          ? true
                                          : false
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Flex>
                        </div>
                      </div>
                    )}
                </div>
                {loginUserData.admin_type === "Super Admin" &&
                  ADDEDITDATA.admin_type !== "Super Admin" && (
                    <div className="inventory_edit_submit_btn">
                      <button
                        type="submit"
                        className="btn btn-primary inventory_save_button"
                      >
                        {" "}
                        Save{" "}
                      </button>
                    </div>
                  )}
              </form>
            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} />
    </div>
  );
};

export default UserListEditPage;
